import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-visualstudiocode',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Visual Studio Code icon</title><path d="M23.15 2.587L18.21.21a1.494 1.494 0 0 0-1.705.29l-9.46 8.63-4.12-3.128a.999.999 0 0 0-1.276.057L.327 7.261A1 1 0 0 0 .326 8.74L3.899 12 .326 15.26a1 1 0 0 0 .001 1.479L1.65 17.94a.999.999 0 0 0 1.276.057l4.12-3.128 9.46 8.63a1.492 1.492 0 0 0 1.704.29l4.942-2.377A1.5 1.5 0 0 0 24 20.06V3.939a1.5 1.5 0 0 0-.85-1.352zm-5.146 14.861L10.826 12l7.178-5.448v10.896z"/></svg>`,
    styles: []
})
export class SimpleIconsVisualstudiocodeComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#007ACC';
    @Input() className: string = 'simple-icons-visualstudiocode'
    constructor() {}
    ngOnInit(): void {}
}
